var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMiddleArrow = function SvgMiddleArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 10 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.008 17.165c.36 0 .612-.251.612-.612V9.529l-.07-1.725.823.98.949.965c.11.118.259.18.431.18a.584.584 0 0 0 .596-.588.58.58 0 0 0-.172-.423l-2.69-2.69C5.33 6.07 5.189 6 5.008 6c-.172 0-.306.063-.47.227l-2.699 2.69a.57.57 0 0 0-.156.424c0 .33.25.588.588.588.165 0 .321-.07.431-.18l.957-.965.808-.972-.07 1.717v7.024c0 .36.258.612.611.612"
  })));
};
export default SvgMiddleArrow;